export const HTTPStatusCode = {
    NOT_FOUND: 404,
    REQUEST_TIMEOUT: 408,
    CANCELED: 499,
}
